import { useEffect, useState } from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';
import SnapCalorieSitePage from '../../components/SnapCalorieSitePage';
import { SplitBox, TextWrap as Text, View, TextInput, HelperText, styles as sc } from '../../components/Themed';
import { RootStackScreenProps } from '../../navigation/navigationTypes';
// Image assets
import TextButton from '../../components/elements/TextButton';
import apiConst from '../../constants/Api';

export default function Register({ navigation, route }: RootStackScreenProps<'Register'>) {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [code, setCode] = useState(() => route.params?.code || '');
  const [codeValid, setCodeValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const onChangeEmailText = (newText: string) => setEmail(newText.trim());
  const onCodeChangeText = (newText: string) => setCode(newText);
  const onChangeName = (newText: string) => setName(newText);

  const hasNameErrors = () => {
    return name.length < 1;
  };

  const hasEmailErrors = () => {
    return !email.includes('@') || !email.includes('.');
  };

  const hasCodeErrors = () => {
    return code.length < 4;
  };

  const formValid = () => {
    return !hasCodeErrors() && !hasEmailErrors() && !hasNameErrors();
  };

  const validateRegistrationCode = async () => {
    const reqUrl = `${apiConst.backendUrl}/record/a-${code}`;
    fetch(reqUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((resp) => {
      if (resp.status === 200) {
        resp
          .json()
          .then((respJson) => {
            console.log(respJson);
            if (Array.isArray(respJson) && respJson.length > 0 && 'value' in respJson[0] && respJson[0].value) {
              const parsedValue = JSON.parse(respJson[0].value);
              if (parsedValue.valid) {
                setCodeValid(true);
              } else {
                setCodeValid(false);
              }
            } else {
              setCodeValid(false);
            }
          })
          .catch((err) => {
            console.log(err);
            setCodeValid(false);
          });
      } else {
        console.error(resp.statusText);
      }
    });
  };

  const handleSubmit = () => {
    setSubmitted(true);
    validateRegistrationCode();
  };

  useEffect(() => {
    setSubmitted(false);
    setCodeValid(false);
  }, []);

  useEffect(() => {
    if (submitted && codeValid) {
      AsyncStorage.setItem('@snapcalorie_checkout_email_address', email);
      AsyncStorage.setItem('@snapcalorie_checkout_name', name);
      AsyncStorage.setItem('@snapcalorie_registration_code', code);
      navigation.navigate('CreateAccount');
    }
  }, [code, codeValid, email, name, navigation, submitted]);

  return (
    <SnapCalorieSitePage
      headerLinks={{
        Home: () => {
          navigation.navigate('Home');
        },
      }}
    >
      <SplitBox
        flex={[1]}
        mobileView={false}
        style={{
          paddingTop: 50,
          alignSelf: 'center',
        }}
        key="SplitBox"
      >
        <View
          style={{
            maxWidth: 300,
          }}
          key="ContainerView"
        >
          {isLoading && <Text style={[sc.blockParagraph, { textAlign: 'center' }]}>Loading.</Text>}
          {!isLoading && (
            <>
              <Text style={[sc.blockParagraph, { textAlign: 'center' }]}>Create your account</Text>
              <TextInput placeholder="Name" value={name} onChangeText={onChangeName} />
              <HelperText style={submitted ? sc.invalidText : sc.hintText} visible={hasNameErrors()}>
                Please enter your name.
              </HelperText>
              <TextInput
                placeholder="Email Address"
                value={email}
                onChangeText={onChangeEmailText}
                disabled={isLoading}
              />
              <HelperText style={submitted ? sc.invalidText : sc.hintText} visible={hasEmailErrors()}>
                Email address is invalid.
              </HelperText>
              <TextInput
                placeholder="Registration Code"
                value={code}
                onChangeText={onCodeChangeText}
                disabled={isLoading}
              />
              <HelperText
                style={submitted ? sc.invalidText : sc.hintText}
                visible={hasCodeErrors() || (submitted && !codeValid)}
              >
                {submitted && !codeValid ? `Registration code is invalid.` : `Enter your registration code`}
              </HelperText>
              <TextButton
                onPress={() => {
                  handleSubmit();
                }}
                text="Continue"
                textStyle={sc.buttonText}
                disabled={!formValid()}
                style={[sc.buttonWrapper, { backgroundColor: '#2364AA' }]}
              />
            </>
          )}
        </View>
      </SplitBox>
    </SnapCalorieSitePage>
  );
}
